// extracted by mini-css-extract-plugin
export default {"customFont":"TableComponent_customFont__CcanJ"};